import { GridColDef } from "@mui/x-data-grid-pro";
import { AddGeneralCodeDialog } from "components/alove/AddGeneralCodeDialog";
import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { TwoSizeChip } from "components/alove/Chips";
import { TablePage } from "components/alove/TablePage";
import { setCurrentDialog, useMaterialUIController } from "context";
import { PermissionType } from "models/BO/BoRole";
import { AISimulation, AiSimulationModel } from "models/AISimulation";
import { useNavigate } from "react-router-dom";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";
import { getAISimulations } from "utils/AISimulationUtils";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { formatDate } from "utils/globalsUtils";
import { UserName } from "components/alove/UserName";
import { getByEmailPhone, getNamesAsync, getNamesByProfileIds } from "utils/enduserUtils";
export const AISimulationsList = () => {
  const [controller, dispatch] = useMaterialUIController();
  const navigate = useNavigate();
  const columns: GridColDef[] = [
    {
      headerName: "Id",
      field: "id",
      valueFormatter: (v) => `#${v}`,
    },
    {
      headerName: "Model",
      field: "model",
      width: 200
    },
    {
      headerName: "Profile",
      field: "profileId",
      renderCell: (params) => {
        return <UserName userId={params.row.profileId} />
      }
    },
    {
      headerName: "Executed At",
      field: "executedAt",
      width: 150,
      valueFormatter: (v) => formatDate(v)
    },
    {
      headerName: "Description",
      field: "description",
      flex: 1
    }
    
    
  ];

  const loadAISimulations = async (filters: any) => {
   const simulations = await getAISimulations(filters);

   getNamesByProfileIds(simulations.map(s => s.profileId));

   return simulations;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="AI Simulations" />
      <TablePage
        actions={{
          title: "AI Simulations actions",
          addActions: [
            {
              label: "AI Simulation",
              onClick: () => navigate("/AISimulations/new"),
              variant: "contained",
              color: "secondary",
            },
            {
              label: "Category",
              onClick: () => setCurrentDialog(dispatch, DialogType.AddGeneralCode),
              variant: "contained",
              color: "secondary",
            }
          ],
        }}
        table={{
          loadNext: loadAISimulations,
          columns,
          lineClick: (AISimulation) => !isNaN(AISimulation.id) && navigate(`/AISimulations/${AISimulation.id}`),
          
        }}
        title="AI Simulations"
        filters={[
         {
            label: "Model",
            options: Object.values(AiSimulationModel).map(m => ({label: m, key: m}))
          }
        ]}
      />
    </DashboardLayout>
  );
};
